// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLitBulb = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.074 20.43H9.836a.418.418 0 1 1 0-.832h4.238a.418.418 0 0 1 0 .833zM14.074 21.682H9.836a.418.418 0 1 1 0-.833h4.238a.418.418 0 0 1 0 .833zM13.33 22.934h-2.795a.418.418 0 1 1 0-.833h2.794a.418.418 0 1 1 0 .833z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.298 15.909a2.812 2.812 0 0 0-.81 1.988v.59a.419.419 0 0 1-.414.418H9.83a.418.418 0 0 1-.419-.418v-.59a2.98 2.98 0 0 0-.84-2.023s-2.348-2.18-2.348-4.645a5.733 5.733 0 0 1 11.461 0c0 2.304-2.386 4.68-2.386 4.68zM11.99 3.494V1.066M6.641 5.719 4.927 4M4.433 11.07H2.002M6.654 16.42l-1.717 1.717M17.355 16.406l1.718 1.718M21.997 11.054h-2.43M17.345 5.705l1.717-1.718"
    />
  </svg>
);
export default SvgLitBulb;
